import { render, staticRenderFns } from "./AttributesDebugger.vue?vue&type=template&id=445c2f04&scoped=true&"
import script from "./AttributesDebugger.vue?vue&type=script&lang=ts&"
export * from "./AttributesDebugger.vue?vue&type=script&lang=ts&"
import style0 from "./AttributesDebugger.vue?vue&type=style&index=0&id=445c2f04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445c2f04",
  null
  
)

export default component.exports